import CardInfoOfVehiclePart from './CardInfoOfVehiclePart'

export default CardInfoOfVehiclePart
